export default {
  form: {
    preparation_time: {
      label: 'Introduce tiempo personalizado (minutos):',
      placeholder: 'Introduce los minutos',
    },
  },
  buttons: {
    custom: 'Personalizado',
  },
  feedback: {
    preparation_time_required: 'El tiempo de preparación debe ser mayor de 0 minutos',
    min_preparation_time: 'Mínimo {{minutes}} minutos de tiempo de preparación para entrega externa',
    max_preparation_time: 'Máximo {{minutes}} minutos de tiempo de preparación',
  },
};
